import React, { useEffect } from 'react';
import { Model } from 'survey-core';
import * as SurveyAnalyticsTabulator from 'survey-analytics/survey.analytics.tabulator';
import 'jspdf-autotable';

const vizPanelOptions = {
  allowHideQuestions: false,
  hasHeader: false,
};

const ChangeInsightsReportTable = (props) => {
  const { surveyResponses, surveyJson } = props;

  useEffect(() => {
    const survey = new Model(surveyJson);

    const vizPanel = new SurveyAnalyticsTabulator.Tabulator(
      survey,
      surveyResponses,
      vizPanelOptions
    );
    vizPanel._columns = vizPanel._columns.filter(
      (r) =>
        r.question.jsonObj.type === 'text' ||
        r.question.jsonObj.type === 'comment'
    );
    vizPanel.render('surveyDashboardContainer');

    return () => {};
  }, [surveyResponses, surveyJson]);

  return <div id="surveyDashboardContainer" />;
};

export default ChangeInsightsReportTable;
